import styled from 'styled-components';
import React from 'react';
import { select } from '~/lib/select';
import { useMediaPlayerStore } from './MediaPlayerProvider';
import { MediaPlayerStore } from './MediaPlayerStore';
import { ReplayButtonEds } from '~/ui/buttons/ReplayButtonEds';

const Button = styled(ReplayButtonEds)`
  position: fixed;
  bottom: 8px;
  left: 8px;
  z-index: 9000;

  /* @media ((max-width: 580px) and (max-height: 300px)) {
    bottom: 5px;
    left: 10px;
  } */
`;

const selector = (s: MediaPlayerStore) =>
  select(s, 'currentTime', 'status', 'restart', 'play');

export const ReplayMediaBtn = () => {
  const { currentTime, status, restart, play } = useMediaPlayerStore(selector);

  if (!currentTime || status === 'nomedia' || status !== 'done') return null;

  return (
    <Button
      onClick={() => {
        restart();
        setTimeout(() => play(), 300);
      }}
    />
  );
};
